import React, {PureComponent} from 'react';

const ACTIVE_CLASS = 'wincalc-frame-selector-selected';
export default class Frame extends PureComponent{

	render(){
		const {idTypeWindowData, onUpdateWindowsLeaf, typewindowdata, activeClassElement} = this.props;

		// определить количество створок, исходя из id в typeWindowData
		const idx = [...typewindowdata].findIndex(el => el.id === idTypeWindowData);
		const countWindows = typewindowdata[idx].countWindows;

		const wrapperClassName = `wincalc-frame wincalc-frame-${countWindows}`;

		this.onFrameClick = (e, id, value) => {
			const element = e.target,
				elementClass = element.className.replace(' ', ''),
				frame = element.closest('.wincalc-frame'),
				image = element.parentNode.nextElementSibling;

			// repeat click on selected input
			if (element.classList.contains('wincalc-frame-selector-selected')) return;

			image.classList.remove('d-none');
			this.animationFrame(elementClass, image, frame);
			this.changeActiveElement(element);
			onUpdateWindowsLeaf(id, value);
		}

		return(
			<div className={wrapperClassName}>
				<div className="wincalc-frame-selector">

					<button type="button"
							className={`wincalc-frame-selector-g  ${(activeClassElement === 'g' ? ACTIVE_CLASS : '' )}`}
							onClick={(e) => {
								// idTypeWindowData - тут хранится id выбранной створки, указывается в frames.js вручную
								this.onFrameClick(e, idTypeWindowData, 'g');
							}}>
						Глухая створка
					</button>

					<button type="button"
							className={`wincalc-frame-selector-p ${(activeClassElement === 'p' ? ACTIVE_CLASS : '' )}`}
							onClick = { (e) => {
								this.onFrameClick(e, idTypeWindowData, 'p');
							}}>
						Поворотная створка
					</button>

					<button type="button"
							className={`wincalc-frame-selector-o ${(activeClassElement === 'o' ? ACTIVE_CLASS : '' )}`}
							onClick = { (e) => {
								this.onFrameClick(e, idTypeWindowData, 'o');
							}}>
						Поворотно-откидная створка
					</button>

				</div>
				<img src={this.props.img} alt=".." className={(activeClassElement === 'g') ? "d-none" : ""} />
			</div>
		)
	}

	// CUSTOMIZING FUNCTION
	animationFrame(cls, image, frame){
		cls = cls.replace(" ", "");
		switch(cls){
			case 'wincalc-frame-selector-g' : {
				image.classList.add('d-none');
				break;
			}
			case 'wincalc-frame-selector-p' : {
				if (frame.querySelectorAll('.animation-o').length > 0) frame.querySelector('.animation-o').classList.remove('animation-o');
				image.classList.add('animation-p');
				break;
			}
			case 'wincalc-frame-selector-o' : {
				if (frame.querySelectorAll('.animation-p').length > 0) frame.querySelector('.animation-p').classList.remove('animation-p');
				image.classList.add('animation-o');
				break;
			}
			default:
				break;
		};
	}

	changeActiveElement(element){
		// find prev selected item and remove selected class
		element.parentNode.querySelector('.wincalc-frame-selector-selected').classList.remove('wincalc-frame-selector-selected');
		// added selected to new element
		element.classList.add(ACTIVE_CLASS);
	}
	// =/CUSTOMIZING FUNCTION
}

